import { APP_MODE, isEmbed, isStandalone, logError } from '../utils';

const isBridgeAPI = (maybeAPI: any): maybeAPI is DatabaseBridgeAPI => {
  return (
    maybeAPI &&
    typeof maybeAPI.spaceKey === 'string' &&
    typeof maybeAPI.sessionData === 'object' &&
    typeof maybeAPI.flags === 'object' &&
    typeof maybeAPI.dialogs === 'object' &&
    typeof maybeAPI.updateBoardStatus === 'function'
  );
};

export const getBridgeAPI = (): DatabaseBridgeAPI => {
  if (isStandalone()) {
    const api = parent.window.databaseBridge;
    if (!isBridgeAPI(api)) {
      const error = new Error('Bridge does not have correct content');
      logError(error);
      throw error;
    }

    // Instead of strict checking for this service, set it to object
    // that implements interface to prevent runtime errors.
    // HOT-109604
    if (api.onboardingService === undefined) {
      api.onboardingService = {
        onOnboardingChange: () => {},
      };
    }

    return api;
  } else if (isEmbed()) {
    return {
      sessionData: {
        userId: '',
      },
      spaceKey: '',
      flags: {},
      dialogs: {
        showDialog: () => {},
        hideDialog: () => {},
      },
      onboardingService: {
        onOnboardingChange: () => {},
      },
      updateBoardStatus: () => {},
      onContentLoadSucceeded: () => {},
      onContentLoadFailed: () => {},
    };
  } else {
    const error = new Error('Bridge is not available in current mode: ' + APP_MODE);
    logError(error);
    throw error;
  }
};

export interface DatabaseBridgeAPI {
  sessionData: DatabaseSessionData;
  spaceKey: string;
  flags: Flags;
  dialogs: Dialogs;
  onboardingService: DatabaseOnboardingService;
  updateBoardStatus: (data: { status: string; tooltipText: string | undefined }) => void;
  onContentLoadSucceeded: (attributes: any) => void;
  onContentLoadFailed: (error: any, attributes: any) => void;
}

export interface DatabaseSessionData {
  userId: string;
}

interface Flags {
  [key: string]: any;
}

interface Dialogs {
  showDialog: any;
  hideDialog: any;
}

interface DatabaseOnboardingService {
  onOnboardingChange?: (screen: string) => void;
}

declare global {
  interface Window {
    databaseBridge: DatabaseBridgeAPI;
  }
}
